<mat-toolbar class="header-toolbar">
  <div class="header-left">
    <div class="breadcrumbs" *ngIf="breadcrumbs.length > 0">
      <span
        *ngFor="let breadcrumb of breadcrumbs; let last = last"
        class="breadcrumb-item"
        [class.current]="last"
        [class.clickable]="!last"
        (click)="!last && onBreadcrumbClick(breadcrumb)"
      >
        <span class="breadcrumb-label">{{ breadcrumb.label }}</span>
        <mat-icon *ngIf="!last" class="separator">chevron_right</mat-icon>
      </span>
    </div>
  </div>

  <div class="header-right">
    @if (showMenuSearch) {
      <button
        mat-icon-button
        type="button"
        class="menu-search-trigger"
        ewentsTooltip="Search menu (⌘F)"
        ewentsTooltipPosition="below"
        aria-label="Search menu"
        (click)="openMenuSearch()"
      >
        <mat-icon>search</mat-icon>
      </button>
    }

    @if (showSupport) {
      <button
        mat-icon-button
        type="button"
        class="menu-search-trigger"
        data-testid="header-support-ticket"
        ewentsTooltip="Report an issue"
        ewentsTooltipPosition="below"
        aria-label="Report an issue"
        (click)="openSupportTicket()"
      >
        <mat-icon>support_agent</mat-icon>
      </button>
    }

    <app-notification-bell></app-notification-bell>

    <button
      mat-button
      type="button"
      class="user-menu-trigger"
      [ewentsTooltip]="getDisplayName()"
      ewentsTooltipPosition="below"
      (click)="navigateToProfile()"
    >
      <span class="user-pill">
        <app-avatar
          class="user-avatar"
          [avatarUrl]="currentUser?.avatarUrl ?? currentUser?.contact?.avatarUrl"
          [name]="getDisplayName()"
          [size]="32"
          shape="round"
          [alt]="getDisplayName()"
        ></app-avatar>
        <span class="user-name">{{ getDisplayName() }}</span>
      </span>
    </button>
  </div>
</mat-toolbar>

@if (showMenuSearch) {
  <app-menu-search [(open)]="menuSearchOpen"></app-menu-search>
}
